import { render } from "./MyLogin_side.vue?vue&type=template&id=f191bcd0"
import script from "./MyLogin_side.vue?vue&type=script&lang=js"
export * from "./MyLogin_side.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__